import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots } from 'vue';
import type { CButtonVariant } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CButton',
  props: {
    ddName: null,
    text: null,
    icon: null,
    hoverIcon: null,
    size: { default: 'md' },
    variant: null,
    disabled: { type: Boolean },
    type: { default: 'button' },
    iconPosition: { default: 'left' },
    gradientColors: { default: () => ['#7258e0', '#88c3d1'] }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'click', e: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { ddName?: string, text?: string, icon?: string | string[], hoverIcon?: string | string[], size: string, variant?: CButtonVariant, disabled?: boolean, type: 'button' | 'submit', iconPosition: 'left' | 'right', gradientColors: string[] };





const slots = useSlots();
const isHover = ref(false);

const gradientStyle = computed(() => {
    if (btnVariant.value !== 'gradient') return {};
    return {
        'background-image': `linear-gradient(to right, ${props.gradientColors.join(', ')})`,
        border: 'none',
        color: '#fff'
    };
});

const btnVariant = computed(() => (props.variant?.length ? props.variant : 'empty'));

const getVisibleIcon = computed(() => {
    if (isHover.value && props.hoverIcon) {
        return props.hoverIcon;
    }
    return props.icon;
});

const buttonClasses = computed(() => {
    return props.iconPosition === 'right' ? 'd-flex align-items-center justify-content-center position-relative' : '';
});

const textClasses = computed(() => {
    return props.iconPosition === 'right' ? 'flex-grow-1 text-left' : '';
});

return { __sfc: true,props, emit, slots, isHover, gradientStyle, btnVariant, getVisibleIcon, buttonClasses, textClasses }
}

})